import { MDBContainer } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";

//common component
import Header from "../../components/header/header-one";
import Sidebar from "../../components/sidebar/sidebar-one";

//component
import UserListing from "./component/user.listing";
import WalletLog from "./component/modalbox.wallet.log";
import TicketLog from "./component/modalbox.ticket.log";
import CreateModalBox from "./component/create.modalbox";
import InfoModalBox from "./component/info.modalbox";
import Gif from "../../assets/fonts/loader/loader.gif";
import SignalSetting from "../SignalUi";

//api service
import useWindowDimensions from "../../components/common/window-dimension";
import apiServices from "../../services/api.services";

export default function User() {
  const [loader, setLoader] = useState(false);
  const [openSideBar, setOpenSideBar] = useState(true);
  const [openSetting, setOpenSetting] = useState(false);

  //data for api
  const [type, setType] = useState("user"); //control role
  const [start, setStart] = useState(0); //paginate
  const [length, setLength] = useState(10); //paginate
  const [order, setOrder] = useState("desc"); // asc or desc
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(); //filter date
  const [endDate, setEndDate] = useState(); //filter date
  //date for render
  const [listingData, setListingData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayRecords, setDisplayRecords] = useState(0);
  //handle modalbox
  const [actionValue, setActionValue] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [selectedId, setSelectedId] = useState("selectedId");
  const [infoModalBoxData, setInfoModalBoxData] = useState({});
  //handle apply filter
  const [handleApplyFilter, setHandleApplyFilter] = useState(false);

  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width >= "767") {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [width]);

  const getListing = async () => {
    const response = await apiServices.getAllListing({
      api_name: "user",
      type,
      search,
      order,
      startDate,
      endDate,
      length,
      start,
    });
    if (response) {
      setLoader(false);
      setListingData(response.aaData);
      setTotalRecords(response.iTotalRecords);
      setDisplayRecords(response.iTotalDisplayRecords);
    }
  };

  const getInfoDetail = async () => {
    const response = await apiServices.getUserInfo(selectedId);
    if (response) {
      setInfoModalBoxData(response);
    }
  };

  useEffect(() => {
    getListing();
    if (search === "") {
      // setLoader(true);
    }
  }, [search, length, handleApplyFilter, start]);

  useEffect(() => {
    if (selectedId >= 0) {
      getInfoDetail();
    }
  }, [selectedId]);

  const handleOpenSideBar = () => {
    setOpenSideBar(!openSideBar);
  };

  const handleCloseModal = () => {
    setInfoModalBoxData({});
    setActionValue(false);
    setSelectedId("selectedId");
  };

  const handleActionChange = (selectedOption, selectedDataRow) => {
    setActionValue(selectedOption);
    setSelectedId(selectedDataRow.id);
  };

  const createAble = () => {
    setCreateModal(!createModal);
  };

  return (
    <MDBContainer className="main-container" breakpoint="none">
      <div className="grid-container">
        <Sidebar isOpen={openSideBar} handleSideBar={handleOpenSideBar} />
        {actionValue == "Ticket Log" && (
          <TicketLog show={true} title="Ticket Log" close={setActionValue} />
        )}
        {actionValue == "Wallet Log" && (
          <WalletLog show={true} title="Wallet Log" close={setActionValue} />
        )}
        {actionValue == "information" &&
          Object.keys(infoModalBoxData).length > 0 && (
            <InfoModalBox
              show={true}
              getListing={getListing}
              selectedData={infoModalBoxData}
              close={handleCloseModal}
            />
          )}
        {createModal && (
          <CreateModalBox
            show={true}
            getListing={getListing}
            title="Create New User"
            close={createAble}
          />
        )}
        {openSetting && <SignalSetting setOpenSetting={setOpenSetting} />}

        <div className="page-container">
          <Header
            handleSideBar={handleOpenSideBar}
            setOpenSetting={setOpenSetting}
          />
          {loader ? (
            <div className="loader">
              <img src={Gif} />
            </div>
          ) : (
            <UserListing
              length={length}
              start={start}
              createAble={createAble}
              listingData={listingData}
              totalRecords={totalRecords}
              displayRecords={displayRecords}
              setListingData={setListingData}
              setSearch={setSearch}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setOrder={setOrder}
              setLength={setLength}
              setStart={setStart}
              // handleNewModal={handleNewModal}
              actionValue={actionValue}
              // createAble={handleNewModal}
              handleActionChange={handleActionChange}
              getListing={getListing}
              setHandleApplyFilter={setHandleApplyFilter}
            />
          )}
        </div>
      </div>
    </MDBContainer>
  );
}
